import { jsx as _jsx } from "react/jsx-runtime";
import { pathgen } from 'object-path-generator';
import { LoadingText } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export const LoadingIndicatorTestIds = pathgen('LoadingIndicatorTestIds');
export default function LoadingIndicator(param) {
    let { testId = LoadingIndicatorTestIds.Root() } = param;
    const { t } = useLocaleKeys('components.loadingIndicator');
    return /*#__PURE__*/ _jsx(LoadingText, {
        testId: testId,
        children: t.loading()
    });
}
